.cal-month {
  border-collapse: collapse;
}

.cal-month-top {
  font-weight: 400;
  text-align: left;
  color: var(--button-text);
  padding: 2px;
  text-transform: uppercase;
}

.cal-month-day {
  width: 14%;
}

.cal-month-nav {
  cursor: pointer;
  border-bottom: solid 1px var(--calendar-border);
  border-top: solid 1px var(--calendar-border);
}

.cal-month-nav:hover {
  background-color: var(--hover-light);
}

.cal-month-weeksel {
  width: 16px;
  border: solid 1px var(--calendar-border);
  padding: 0 4px 1px;
}

.cal-month-monthsel {
  width: 25px;
}

.cal-month-cell {
  border: solid 1px var(--calendar-border);
  vertical-align: top;
}

.cal-month-cell > div > div:first-child {
  margin-right: auto;
}

.cal-month-cell > div > div:nth-child(2) {
  display: none;
}

.cal-month-cell:hover div.cal-month-add-item {
  display: block;
  cursor: pointer;
}

.cal-month-day-title {
  display: flex;
  margin: 0 1px 2px;
  padding: 0 4px 1px;
}

.cal-month-weeksel:hover,
.cal-month-cell .cal-month-day-number:hover {
  cursor: pointer;
  text-decoration: underline;
}

.cal-month-day-items {
  min-height: 110px;
}

.cal-month-not-current {
  color: var(--main-text-disabled);
}

.cal-month-today {
  background-color: var(--button-border-disabled);
}
